export default __webpack_public_path__ + "static/media/craon33.81b6b65e.jpg";